import axios from './http'
import qs from 'qs'

export default {
    // 竞赛页面
    competitionListUrl (params) {
        return axios.post('/api/common/getNewCmptList.json', qs.stringify(params)) // 竞赛列表
    },
    competitionDetailsUrl (params) {
        return axios.get('/v3/api/common/cmpt/cmptDetail.json', {params})// 获取竞赛详情页  默认竞赛信息tab
    },
    // 获取竞赛的id （根据name）
    getCpmId (params) {
        return axios.get('/v3/api/user/message/findCmptIdByName.json', {params})
    },
    getCpmtIdNoLogin (params) {
        return axios.get('/v3/api/common/cmpt/findCmptIdByName.json', {params})
    },
    inviteFriendUrl (params) {
        return axios.post('/v3/api/cmpt/inviteMem.json', qs.stringify(params)) // 邀请好友
    },
    createTeamUrl (params) {
        return axios.post('/v3/api/cmpt/createTeam.json', qs.stringify(params)) // 创建队伍
    },
    competitionSubmitUrl (params) {
        return axios.post('/api/common/mySubmission.html', qs.stringify(params)) // 竞赛提交结果tab
    },
    competitionRankingUrl (params) {
        return axios.get('/v3/api/common/cmpt/rankList.json', {params}) // 竞赛排行榜tab
    },
    rankingTeamUrl (params) {
        return axios.post('/api/common/cd_DcTeamDtails.html', qs.stringify(params)) // 排行榜队伍主页
    },
    weekTopRankingUrl (params) {
        return axios.get('/v3/api/common/cmpt/weekRankList.json', {params}) // 周排行榜
    },
    articleListUrl (params) {
        return axios.post('/api/common/bbs/getAllTopicList.html', qs.stringify(params)) // 获取竞赛圈全部文章
    },
    articleDetailUrl (params) {
        return axios.post('/api/common/bbs/topicDetails.html', qs.stringify(params)) // 获取竞赛文章详情内容
    },
    articleReplyUrl (params) {
        return axios.post('/api/common/bbs/topicReply.html', qs.stringify(params)) // 获取竞赛文章详情回复
    },
    articlePraiseUrl (params) {
        return axios.put('/api/user/bbs/topic/praise.json', qs.stringify(params)) // 提交竞赛文章点赞
    },
    articleReplyPraiseUrl (params) {
        return axios.put('/api/user/bbs/reply/praise.json', qs.stringify(params)) // 提交竞赛文章回复点赞
    },
    articleCommentsUrl (params) {
        return axios.post('/api/user/bbs/replyTopic.json', qs.stringify(params)) // 回复竞赛圈文章 评论
    },
    competitorUrl (params) {
        return axios.get('/v3/api/common/cmpt/findCompetitorList.json', {params}) // 全部参赛人员
    },
    competitionTeamUrl (params) {
        return axios.get('/v3/api/common/cmpt/findTeamPage.json', {params}) // 全部参赛团队
    },
    quitTeamUrl (params) {
        return axios.post('/api/user/team/deleteCompeteMate.json', qs.stringify(params)) // 退出队伍
    },

    bannerUrl () {
        return axios.get('/v3/api/common/findBannerList.json') // 首页banner
    },
    topicIndexUrl (params) {
        return axios.post('/api/common/bbs/topicIndex.html', qs.stringify(params)) // 首页竞赛圈轮播数据
    },
    getDCWXAppIndexCmptListUrl (params) {
        return axios.post('/api/common/getDCWXAppIndexCmptList.json', qs.stringify(params)) // 首页精选竞赛/首页新手训练赛/首页高阶挑战赛
    },
    getCmptListES (params) {
        return axios.get('/v3/api/common/cmpt/getCmptListES.json', {params: params}) // 首页精选竞赛/首页新手训练赛/首页高阶挑战赛
    },
    getPlatformTotalCmptInfoUrl () {
        return axios.post('/api/common/getPlatformTotalCmptInfo.json') // 政企办赛,四组数据
    },
    editCompanyHoldCompetitionUrl (params) {
        return axios.post('/api/common/editCompanyHoldCompetition.json', qs.stringify(params)) // 政企办赛 快速办赛提交信息
    },
    getHallOfFameListUrl (params) {
        return axios.post('/api/static_page/hallOfFame.html', qs.stringify(params)) // 名人堂
    },
    heroLegendsUrl (params) {
        return axios.post('/api/common/rank/year.html', qs.stringify(params)) // 年度英雄榜
    },
    findUserMsgByPageUrl (params) {
        return axios.post('/api/user/msg/findUserMsgByPage.json', qs.stringify(params)) // 年度英雄榜
    },
    monthTop3Url (params) {
        return axios.post('/api/common/rank/monthTop3.html', qs.stringify(params)) // 历史月top3
    },
    loginUrl (params) {
        return axios.post('/api/user/common/login.json', qs.stringify(params)) // 登录
    },
    ssoLogin (params) {
        return axios.post('/v3/api/common/ssoLogin', qs.stringify(params)) // sso登录
    },
    // judgeUserAgreeRules (params) {
    //     return axios.post('/api/user/team/judgeUserAgreeRules.json', qs.stringify(params)) // 判断老用户是否同意隐私政策
    // },
    agreeUserRules (params) {
        return axios.post('/api/user/team/agreeUserRules.json', qs.stringify(params)) // 同意隐私政策
    },
    beforeCreateTeam (params) {
        // return axios.post('/api/user/team/beforeCreateTeam.json', qs.stringify(params)) // 报名前判断是否收集信息
        return axios.get('/v3/api/cmpt/beforeCreateTeam.json', {params}) // 报名前判断是否收集信息
    },
    passCollectUserInfo (params) {
        return axios.post('/api/user/team/passCollectUserInfo.json', qs.stringify(params)) // 同意收集信息
    },
    userNameCheckUrl (params) {
        return axios.post('/api/user/common/userNameIsExist.json', qs.stringify(params)) // 用户名check
    },
    clickCaptchaUrl () {
        return axios.post('/api/common/allow/clickCaptcha') // 点击发送验证码
    },
    sendPhoneAuthCodeUrl (params) {
        return axios.post('/api/user/common/sendPhoneAuthCode.json', qs.stringify(params)) // 发送验证码（手机注册）
    },
    regUrl (params) {
        return axios.post('api/user/common/register.json', qs.stringify(params)) // 注册
    },
    resetpasswordNewUrl (params) {
        return axios.post('/api/user/common/ResetpasswordNew.json', qs.stringify(params)) // 设置新密码（手机找回&&邮箱找回）
    },
    sendEmailForResetUrl (params) {
        return axios.post('/api/user/common/sendEmailForReset.json', qs.stringify(params)) // 发送邮箱验证码（邮箱找回）
    },
    mailForResetUrl (params) {
        return axios.post('/api/user/common/MailForReset.json', qs.stringify(params)) // 邮箱验证码check（邮箱找回）
    },
    sendPhoneAuthUrl (params) {
        return axios.post('/api/user/common/sendPhoneAuthForResetNew.json', qs.stringify(params)) // 发送手机验证码(手机找回)
    },
    phoneAuthForResetUrl (params) {
        return axios.post('/api/user/common/phoneAuthForResetNew.json', qs.stringify(params)) // 手机验证码check(手机找回)
    },
    /* sendPhoneAuthCodeUrl (params) {
            return axios.post('/api/user/common/sendPhoneAuthCode.json', qs.stringify(params)) // 发送验证码（手机注册）
          }, */
    schoolUrl (params) {
        return axios.post('/api/common/dataDictionary/getDataDictionary.json', qs.stringify(params)) // 学校城市等数据
    },
    // cmm
    // 我的-----tab页面数据请求
    userCenterUrl (params) {
        return axios.get('/v3/api/common/user/getUserBasicInfo.json', {params}) // 请求个人信息
    },
    // cmm
    // 我的-----tab页面数据请求
    getToken (params) {
        return axios.get('/v3/api/common/getToken.json', {params}) // 请求个人信息
    },
    getUserOtherSetting (params) {
        return axios.get('/v3/api/user/getUserOtherSetting.json', {params}) // 请求其他信息
    },

    // 获取个人信息
    getUserBaseInfo () {
        return axios.get('/v3/api/user/setting/getUserBaseInfo.json') // 请求个人资料
    },
    unReadNumUrl (params) {
        return axios.get('/v3/api/user/message/noticeNum.json', {params}) // 获取未读信息数量
    },
    // 我的-----个人主页数据请求
    myCmptIndexUrl (params) {
        return axios.post('/api/common/myCmptIndex.html', qs.stringify(params)) // 请求个人主页(竞赛和成就等信息)
    },
    // 我的-----个人主页数据请求
    getUserCmptList (params) {
        return axios.get('/v3/api/common/user/getUserCmptList.json', {params}) // 请求个人主页(竞赛和成就等信息)
    },
    // 我的-----个人主页数据请求
    getUserHonorList (params) {
        return axios.get('/v3/api/common/user/getUserHonorList.json', {params}) // 请求个人主页(竞赛和成就等信息)
    },
    isUserCommonTeam (params) {
        return axios.post('/api/common/isUserCommonTeam.json', qs.stringify(params)) // 判断是否为同一个队伍
    },
    // 我的-----信箱部分
    personalMessageUrl (params) {
        // return axios.post('/api/user/msg/findPrivateLetterByPage.json', qs.stringify(params)) //个人私信列表
        return axios.get('/v3/api/user/message/findPrivateLetterByPage.json', {params}) // 个人私信列表
    },
    // 改变DC通知消息状态
    signMessageStatusUrl (params) {
        return axios.post('/api/user/msg/signMessageStatus.json', qs.stringify(params)) // 个人私信列表
    },
    // dc通知
    dcNoticeUrl (params) {
        return axios.get('/v3/api/user/message/findUserMsgByPage.json', {params})
    },
    // DC通知详情
    dcNoticeDetailUrl (params) {
        return axios.post('/api/user/msg/getDcWxAppNoticeDetail.json', qs.stringify(params))
    },
    // 个人私信详情
    setMessageReadUrl (params) {
        return axios.post('/v3/api/user/message/setMessageRead.json', qs.stringify(params))
    },
    // 聊一下 申请组队之前
    beforeSendMessageApi (params) {
        return axios.get('/v3/api/cmpt/beforeSendMessage.json', {params})
    },
    // 邀请队友之前
    beforeInviteMemApi (params) {
        return axios.get('/v3/api/cmpt/beforeInviteMem.json', {params})
    },

    // 先聊一下 申请组队  待改动
    chatApplyUrl (params) {
        // return axios.post('/api/user/msg/sendMessage.json', qs.stringify(params));
        return axios.post('/v3/api/cmpt/sendMessage.json', qs.stringify(params))
    },
    // 个人信箱详情（组队通知 - 同意或者拒绝  个人信箱详情（发送消息）
    dealApplyUrl (params) {
        // return axios.post('/api/user/team/dealApply.json', qs.stringify(params));
        return axios.post('/v3/api/user/team/dealApply.json', qs.stringify(params))
    },
    // 个人信箱详情（参赛邀请 - 同意或者拒绝
    dealInviteNew (params) {
        // return axios.post('/api/user/team/dealInviteNew.json', qs.stringify(params));
        return axios.post('/v3/api/user/message/dealInviteNew.json', qs.stringify(params))
    },
    // 队伍邀请
    joinTeamMessageUrl (params) {
        return axios.post('/api/user/msg/findTeamMsgByPage.json', qs.stringify(params))
    },
    // 我的意见反馈提交结果
    userFeedbackUrl (params) {
        return axios.post('/api/user/restcommon/userFeedback.json', qs.stringify(params))
    },
    // 我的-----退出登录
    logoutUrl (params) {
        return axios.post('/api/user/common/logout', qs.stringify(params))
    },
    // 账号设置
    sendBindingPhoneAuthUrl (params) { // 手机绑定（发送验证码）
        return axios.post('/api/user/setting/sendPhoneAuth.json', qs.stringify(params))
    },
    // 手机绑定//邮箱绑定（check原手机号（邮箱）是否为本人绑定的号码）
    completeAuthUrl (params) {
        return axios.post('/api/user/setting/completeAuth.json', qs.stringify(params))
    },
    // 手机绑定（验证码验证）
    phoneVerifiedUrl (params) {
        return axios.post('/api/user/setting/phoneVerified.json', qs.stringify(params))
    },
    // 邮箱绑定（发送验证码）
    sendMailAuthUrl (params) {
        return axios.post('/api/user/setting/sendMailAuth.json', qs.stringify(params))
    },
    mailVerifiedUrl (params) {
        return axios.post('/api/user/setting/mailVerified.json', qs.stringify(params))
    },
    // 重置密码
    changePasswordUrl (params) {
        return axios.post('/v3/api/user/setting/changePassword.json', qs.stringify(params))
    },
    // 设置密码
    updatePassword (params) {
        return axios.post('/v3/api/user/setting/updatePassword.json', qs.stringify(params))
    },
    // 实名认证部分
    verifiedUrl (params) {
        return axios.post('/api/user/dcer/verified.html', qs.stringify(params))
    },
    // 判断用户是否证件认证
    isIdCardVerified (params) {
        return axios.get('/v3/api/user/isIdCardVerified.json', {params})
    },
    // 身份信息方式认证,申诉是否被使用
    isCardNoVerifiedUrl (params) {
        return axios.post('/api/user/setting/isCardNoVerified.json', qs.stringify(params))
    },
    // 身份信息方式认证,申诉是否被使用
    cardVerifiedUrl (params) {
        return axios.post('/api/user/setting/cardVerified.json', qs.stringify(params))
    },
    // 实名认证,提交申诉
    userCardApplyUrl (params) {
        return axios.post('/api/user/setting/userCardApply.json', qs.stringify(params))
    },
    // 实名认证,芝麻信用方式
    zhimaUrl (params) {
        return axios.post('/api/user/zhima/init.json', qs.stringify(params))
    },
    // 实名认证,请求芝麻信用二维码
    zhimaCodeUrl (params) {
        return axios.post('/api/user/zhima/qrcode', qs.stringify(params))
    },
    // 轮训是否已经扫码关注
    queryCodeUrl (params) {
        return axios.post('/api/user/zhima/query.json', qs.stringify(params))
    },
    // 个人资料保存个人资料
    editUserInfoUrl (params) {
        return axios.post('/v3/api/user/editUserInfo.json', qs.stringify(params))
    },

    // 判断此用户是否需要强制收集信息
    judgeUserPhoneUrl (params) {
        return axios.post('/api/user/dcer/judgeUserPhone.json', qs.stringify(params))
    },

    // 获取用户强制收集信息状态(弹框)
    getUserCollectInfoUrl () {
        return axios.post('/api/common/getUserCollectInfo.json')
    },
    // 修改用户强制收集信息状态(弹框)
    updateUserCollectInfoUrl () {
        return axios.post('/api/common/updateUserCollectInfo.json')
    },
    // 认证学生教育邮箱(弹框)
    setUserVsiEmailUrl (params) {
        return axios.post('/api/user/team/setUserVsiEmail.json', qs.stringify(params))
    },
    // 中电竞赛提交审核
    submitVerifyUser (params) {
        return axios.post('/api/user/team/submitVerifyUser.json', qs.stringify(params))
    },

    // 获取报名表单信息
    getCmptUserFormInfo (params) {
        return axios.get('/v3/api/cmpt/getCmptUserFormInfo.json', {params})
    },

    // 提交报名表单
    submitCmptUserFormInfo (params) {
        return axios.post('/v3/api/cmpt/submitCmptUserFormInfo.json', qs.stringify(params))
    },

    // 获取赛事新闻列表
    getNewsList (params) {
        return axios.get('/v3/api/common/cmpt/news/getCmptNewsList.json', {params})
    },

    // 获取赛事新闻详情
    getNewsDetail (params) {
        return axios.get('/v3/api/common/cmpt/news/getCmptNewsDetail.json', {params})
    }
}



// WEBPACK FOOTER //
// ./src/api/api.js